export default __webpack_public_path__ + "6ee73e3ad8f070328c943ad38c70b24f.png";